const ArgumentType = require('../extension-support/argument-type');
const BlockType = require('../extension-support/block-type');
const Cast = require('../util/cast');

class Scratch3RandomPlus {
    constructor(runtime) { this.runtime = runtime; }
    getInfo() {
        return {
            id: 'randomPlus', name: '🎲 乱数+', color1: '#FF6B6B', color2: '#EE5A5A',
            blocks: [
                { opcode: 'float', blockType: BlockType.REPORTER, text: '[A]〜[B] の小数乱数', arguments: { A: { type: ArgumentType.NUMBER, defaultValue: 0 }, B: { type: ArgumentType.NUMBER, defaultValue: 1 } } },
                { opcode: 'bool', blockType: BlockType.BOOLEAN, text: 'ランダムな真偽値' },
                { opcode: 'sign', blockType: BlockType.REPORTER, text: 'ランダムな符号' },
                { opcode: 'char', blockType: BlockType.REPORTER, text: 'ランダムな文字' },
                { opcode: 'uuid', blockType: BlockType.REPORTER, text: 'UUID生成' },
                { opcode: 'chance', blockType: BlockType.BOOLEAN, text: '[P]% の確率', arguments: { P: { type: ArgumentType.NUMBER, defaultValue: 50 } } }
            ]
        };
    }
    float(args) { var a = Cast.toNumber(args.A), b = Cast.toNumber(args.B); return Math.random() * (b - a) + a; }
    bool() { return Math.random() < 0.5; }
    sign() { return Math.random() < 0.5 ? 1 : -1; }
    char() { return 'abcdefghijklmnopqrstuvwxyz'[Math.floor(Math.random() * 26)]; }
    uuid() { return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) { var r = Math.random() * 16 | 0; return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16); }); }
    chance(args) { return Math.random() * 100 < Cast.toNumber(args.P); }
}
module.exports = Scratch3RandomPlus;